import type { Raid } from "../rest/RaidSchema.ts";
import { Tag } from "antd";

export function statusColumnHelper(status: Raid["status"]) {
  switch (status) {
    case "CREATED":
      return <Tag color="geekblue">Erstellt</Tag>;
    case "CLOSED":
      return <Tag color="red">Beendet</Tag>;
    case "RUNNING":
      return <Tag color="green">Laufend</Tag>;
  }
}